import * as React from 'react';

import {Button} from 'shells/button/button';

import type {MeetingFragment as Meeting} from 'nutshell-graphql-types';

import {CreateMeetingModal} from '../create-modals/multi-host/create-meeting-modal';

type Props = {
    meeting: Meeting;
};

export function AddCohostsButton(props: Props) {
    const [isAdding, setIsAdding] = React.useState<boolean>(false);

    return (
        <>
            <Button
                variant='text-primary'
                size='normal'
                onClick={() => setIsAdding(true)}
                noPadding={true}
            >
                Add co-host(s)
            </Button>
            {isAdding && (
                <CreateMeetingModal onClose={() => setIsAdding(false)} meeting={props.meeting} />
            )}
        </>
    );
}
